// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__qBdjT","buscar":"SearchBar_buscar__3bMHb"};